"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishCampaignRequestToJSON = exports.PublishCampaignRequestFromJSONTyped = exports.PublishCampaignRequestFromJSON = exports.instanceOfPublishCampaignRequest = exports.PublishCampaignRequestActionEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.PublishCampaignRequestActionEnum = {
    Publish: 'PUBLISH',
    Validate: 'VALIDATE'
};
/**
 * Check if a given object implements the PublishCampaignRequest interface.
 */
function instanceOfPublishCampaignRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPublishCampaignRequest = instanceOfPublishCampaignRequest;
function PublishCampaignRequestFromJSON(json) {
    return PublishCampaignRequestFromJSONTyped(json, false);
}
exports.PublishCampaignRequestFromJSON = PublishCampaignRequestFromJSON;
function PublishCampaignRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'action': !(0, runtime_1.exists)(json, 'action') ? undefined : json['action'],
        'draftHierarchyVersion': !(0, runtime_1.exists)(json, 'draft_hierarchy_version') ? undefined : json['draft_hierarchy_version'],
    };
}
exports.PublishCampaignRequestFromJSONTyped = PublishCampaignRequestFromJSONTyped;
function PublishCampaignRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'action': value.action,
        'draft_hierarchy_version': value.draftHierarchyVersion,
    };
}
exports.PublishCampaignRequestToJSON = PublishCampaignRequestToJSON;
